import { t } from "i18next";
import React from "react";

import { ExportIcon } from "../../assets/icons/ExportIcon";
import "./ExportButton.scss";

export const ExportButton = ({
  onClick,
  isCsv,
}: {
  onClick: () => void;
  isCsv?: boolean;
}) => {
  return (
    <button className="export-button" onClick={onClick}>
      <p>{isCsv ? t("common.exportCSV") : t("common.export")}</p>{" "}
      <ExportIcon className="export-icon" />
    </button>
  );
};
